import { Trans, useTranslation } from 'react-i18next'

import { QuoteConstraint } from '../../../modules/quotes'
import { useDateFormatter } from '../../../utils/date'
import { type QuoteJob } from '../../../modules/quotes/core/models/subModels/quoteJob.model'

type useGetConstraintDescriptionOptions = {
  jobQuote?: QuoteJob
}

export const useGetConstraintDescription = () => {
  const { t } = useTranslation()
  const formatDate = useDateFormatter()

  const getDescription = (constraint: QuoteConstraint, { jobQuote }: useGetConstraintDescriptionOptions = {}) => {
    switch (constraint) {
      case QuoteConstraint.unavailableDate: {
        if (!jobQuote) {
          return t('quotes.constraints.unavailableDateMultiJobs')
        }
        const QuoteDate = () => (
          <strong>
            { formatDate(jobQuote.date, { showYear: false, shortMonth: true }) }
          </strong>
        )
        return (
          <Trans i18nKey="quotes.constraints.unavailableDate">
            <QuoteDate />
          </Trans>
        )
      }
      default:
        return t(`quotes.constraints.${constraint}`)
    }
  }
  return getDescription
}
